import React from 'react';
// import ReactGA from 'react-ga4';

// const TRACKING_ID="G-J5CHC3YDC7";
// ReactGA.initialize({TRACKING_ID});
// ReactGA.send("pageview");
import {TopBar} from './components/TopBar/TopBar.js' //Custom AppBar
import {PictureCarousel} from './components/Carousel/Carousel.js'
import {CssBaseline} from '@mui/material';
import tiling from './images/blue-tile.png'

import { ThemeProvider, Typography} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from './theme.js'
import {Footer} from './components/Footer/Footer.js'
import { GameTiles } from './components/GameTiles/GameTiles.js';
import { Reviews } from './components/Reviews/Reviews.js';
import { StickyBottom } from './components/StickyBottom/StickyBottom.js';

const App = () => {
    return (
            <ThemeProvider theme = {theme}>
                <CssBaseline/>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <TopBar/>
                    </Grid>
                    <Grid item xs={12}>
                        <PictureCarousel/>
                    </Grid>
                    <Grid item xs = {12} style={{backgroundImage:`url(${tiling})`, backgroundAttachment: "fixed", borderStyle: "solid", borderWidth: "2px 0px", borderColor:"#e6aa56"}}>
                        <Reviews/>  
                    </Grid>
                    <Grid item xs={12} style={{backgroundImage:`url(${tiling})`, backgroundAttachment: "fixed"}} pt={5}>
                        <Typography variant = "h2" style={{color:"white", textAlign:"center" }} fontFamily="Copperplate">
                            Adventure Awaits! <br/>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} style={{backgroundImage:`url(${tiling})`, backgroundAttachment: "fixed"}}>
                        <GameTiles/>
                    </Grid>
                    <Footer/>
                </Grid>
                <StickyBottom/>
            </ThemeProvider>
    );
}
export default App;